import { fromJS, Iterable } from 'immutable';

import CampaignRecord       from 'records/campaign_record';
import JobRecord            from 'records/job_record';
import CandidateRecord      from 'records/candidate_record';
import CandidateApplication from 'records/candidate_application';
import Address              from 'records/address';
import FolderRecord         from 'records/folder_record';
import PromptRecord         from 'records/prompt_record';
import PromptResponse       from 'records/prompt_response';
import TemplateRecord       from 'records/template_record';
import CandidateAttribute   from 'records/candidate_attribute';

const RECORD_MAP = {
  'data.*.campaign.records.collection.[0-9]+':            CampaignRecord,
  'data.*.campaign.records.collection.[0-9]+.*.origin':   JobRecord,
  'data.*.candidate.attributes.collection.[0-9]+':        CandidateAttribute,
  'data.*.candidate.records.collection.[0-9]+':           CandidateRecord,
  'data.*.applications.(collection|applications).[0-9]+': CandidateApplication,
  'data.*.applications.collection.[0-9]+.*.record':       CandidateRecord,
  'data.*.address':                                       Address,
  'data.*.folder':                                        FolderRecord,
  'data.*.responses.[0-9]+':                              PromptResponse,
  'data.*.(prompts.[0-9]+|prompt)':                       PromptRecord,
  'data.*.template':                                      TemplateRecord,
};

export default function recordJS(json) {
  const path = [];

  return fromJS(json, (key, value) => {
    if (key.length === 0) return value;

    path.push(key);

    if (Iterable.isIndexed(value)) return value.toList();

    let matched;

    Object.entries(RECORD_MAP).some((item) => {
      const pattern = item[0];
      const Rekord = item[1];

      const regex = new RegExp(`^${pattern}$`);
      if (regex.test(path.join('.'))) {
        matched = new Rekord(value);
        return true;
      }
      return false;
    });

    return matched || value.toMap();
  });
}
